import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as startNow from "./style.module.scss";

export const StartNow = () => {
  return (
    <section className={startNow.startNow}>
      <div className="container">
        <h2 className={`${main.title_h2} ${startNow.startNow__title}`}>
          Почему мы рекомендуем начать работать с курсом уже сейчас
        </h2>
        <div className={startNow.startNow__blocks}>
          <div className={startNow.startNow__block}>
            <div className={startNow.startNow__imgWrapper}>
              <img
                src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/recommend-icon-01.svg"
                alt={""}
              />
            </div>
            <p>До тех пор, пока навык чтения недостаточно сформирован, любое обучение будет даваться ребёнку с
              трудом.</p>
          </div>
          <div className={startNow.startNow__block}>
            <div className={startNow.startNow__imgWrapper}>
              <img
                src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/recommend-icon-02.svg"
                alt=""
              />
            </div>
            <p>Школьная программа с каждым годом усложняется — дети, у которых возникают сложности в чтении и восприятии
              текста, оказываются среди отстающих и чаще испытывают негативные эмоции.</p>
          </div>
          <div className={startNow.startNow__block}>
            <div className={startNow.startNow__imgWrapper}>
              <img
                src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/recommend-icon-03.svg"
                alt=""
              />
            </div>
            <p>Ребёнок, в круг интересов которого не входит чтение, чаще берёт в руки гаджеты — возрастает риск
              приобрести цифровую зависимость.</p>
          </div>
        </div>
        <div className={startNow.startNow__videoBlock}>
          <h4>Минутное видеознакомство с курсом<br/>«Как научить ребёнка читать быстро и с умом»</h4>
          <div className={startNow.startNow__video}>
            <div className={`${startNow.startNow__videoWrapper} efficiency__video-wrapper`}>
              <iframe
                src="https://www.youtube.com/embed/y2gEcbYby48"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
